import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
} from 'mdb-react-ui-kit';
import { useState } from 'react';

export default function ChooseReadingDeadlinePopUp(props){
    
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minDate = tomorrow.toLocaleDateString("sv-SE"); // Format as YYYY-MM-DD
    const [readingDeadline, setReadingDeadline] = useState(minDate);

    function handleSetReadingDeadlineACB(deadline){
        console.log("Popup sending deadline:", deadline);
        if(!deadline) return;
        if(props.onChosenBook) props.onChosenBook();
        props.onSetReadingDeadline(deadline);
        props.setShow(false);
    }

    return <div className="mdb-scope">
        <MDBModal open={props.show} setOpen={props.setShow} tabIndex="-1">
        <MDBModalDialog centered={true} size="md">
            <MDBModalContent className="p-4 rounded-lg shadow-lg" onClick={(e) => e.stopPropagation()}>
                <MDBModalHeader>
                    <MDBModalTitle className="font-semibold text-xl">Set Reading Deadline</MDBModalTitle>
                </MDBModalHeader>

                <MDBModalBody className="space-y-4 mt-4">
                    <div className="flex flex-col items-center">
                        <p className="text-amber-700 mb-4 text-center">
                            Set a reading deadline for the chosen book. The book club is supposed to have completed the book on this date.
                        </p>
                        <MDBInput
                            type="date"
                            value={readingDeadline}
                            onChange={(evt) => setReadingDeadline(evt.target.value)}
                        />
                    </div>
                </MDBModalBody>

                <MDBModalFooter className="flex gap-2 justify-end mt-6">
                    <button onClick={() => props.setShow(false)}
                        className="px-4 py-2 border border-blue-200 text-blue-700 !rounded-lg hover:bg-blue-50 transition-colors">
                        Cancel
                    </button>

                    <button
                        onClick={() => handleSetReadingDeadlineACB(readingDeadline)}
                        disabled={!readingDeadline}
                        className={`px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all
                                    ${!readingDeadline ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        Choose this date
                    </button>
                    
                </MDBModalFooter>
            </MDBModalContent>
        </MDBModalDialog>
        </MDBModal>
    </div>

}